import {
  OnInit,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
  VERSION,
  ViewChild,
  ViewContainerRef,
  ElementRef,
  Renderer2,
  AfterContentInit,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { DashboardPersonnelService } from "src/app/new-dashboard/core/service/dashboard-personnel.service";
import { QuantiteDossierPortefeuilleDTO } from "src/app/new-dashboard/core/model/quantite-dossier-portefeuille-dto";
import { TrouverEmployeeModalComponent } from "src/app/formulaire/modal/trouver-employee-modal/trouver-employee-modal.component";

@Component({
  selector: "app-performance",
  templateUrl: "./performance.component.html",
  styleUrls: ["./performance.component.scss"],
})
export class PerformanceComponent {
  isLoadingResults = true;

  username: String;

  @ViewChild("nbTacheEncours", { static: true }) nbTacheEncours: ElementRef;
  @ViewChild("nbTacheACorriger", { static: true }) nbTacheACorriger: ElementRef;
  @ViewChild("nbTacheValide", { static: true }) nbTacheValide: ElementRef;
  @ViewChild("nbTacheEnRetard", { static: true }) nbTacheEnRetard: ElementRef;
  @ViewChild("nbTacheEncoursARegulariser", { static: true })
  nbTacheEncoursARegulariser: ElementRef;
  @ViewChild("nbTacheEncoursNormal", { static: true })
  nbTacheEncoursNormal: ElementRef;
  @ViewChild("donut", { static: true }) donut: ElementRef;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _dashboardPersonnelService: DashboardPersonnelService,
    private _keycloakService: KeycloakService
  ) {
    this.username = _keycloakService.getUsername();
  }

  quantiteDossierPortefeuilleDTO: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();

  ngOnInit() {
    localStorage.setItem("aRegularier", "");

    this.quantiteDossierPortefeuilleByUsername(this.username);
  }

  quantiteDossierPortefeuilleByUsername(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("_", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.isLoadingResults = false;

          this.quantiteDossierPortefeuilleDTO = data;

          this.nbTacheEncours.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreTacheEnCours +
            "</h2>";
          this.nbTacheACorriger.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreDossierAcorrige +
            "</h2>";
          this.nbTacheValide.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreDossierValide +
            "</h2>";
          this.nbTacheEnRetard.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreDossierEnRetard +
            "</h2>";
          this.nbTacheEncoursARegulariser.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreTacheEnCoursARegulariser +
            "</h2>";
          this.nbTacheEncoursNormal.nativeElement.innerHTML =
            '<h2 class="number_counter" data-speed="3000" data-from="1001" data-to="3504">' +
            this.quantiteDossierPortefeuilleDTO.nombreTacheEncoursNormal +
            "</h2>";
        },
        (error) => {
          console.log(error);
        }
      );
  }

  search(): void {
    const modalRef = this.modalService.open(TrouverEmployeeModalComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close

        this.username = data;
        this.quantiteDossierPortefeuilleByUsername(this.username);
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
